import React from 'react'

export default React.createClass({
  render: function () {
    let backgroundColor = this.props.backgroundColor ? '#d8d8d8' : ''
    return (
        <div style={{margin: 'auto',marginTop: 20, backgroundColor: backgroundColor, padding: '18px 30px 18px 30px'}}>
          <div style={{marginBottom: 20, margin: 'auto', width: '75%'}}>
            <p>Name: <strong>{this.props.info.name}</strong></p>
            <p>Email: <strong>{this.props.info.email}</strong></p>
            <p>Cell Number: <strong>{this.props.info.phone}</strong></p>
            <p>Password: <strong>*******</strong></p>
          </div>
          <button className='btn btn-info btn-sm cerulean-blue-background center-block' style={{border: 0, width: 216, height: 42}} onClick={this.props.show}>Edit my info</button>
        </div>
    )}
})



// WEBPACK FOOTER //
// ./src/components/account/user-info.jsx